unit GA.Rules;

interface

//KSS uses WebLib.ExtCtrls, XData.Web.Client, MainDataModule, JS;

type
  TGARulesUtils = class
    class function IsGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string; ADonorClaimStatus: string): boolean;
    class function SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
  end;


implementation


class function TGARulesUtils.IsGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string; ADonorClaimStatus: string): boolean;
begin
  if (ADonorType = 'Individual') and (AAddressLine1 <> '') and (APostCode <> '') and
     (ADonorClaimStatus = 'OK') then
    result := true
  else
    result := false;
end;


class function TGARulesUtils.SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
var
  lOk: boolean;
begin
  lOk := true;
  if ADonorType <> 'Individual' then
    lOk := false;
  if (ADonorType = 'Individual') and ((AAddressLine1 = '') or (APostCode = '')) then
    lOk := false;

  result := lOk;
end;

end.
